import { render, staticRenderFns } from "./PopupButtons.vue?vue&type=template&id=8540f5b0&scoped=true&"
import script from "./PopupButtons.vue?vue&type=script&lang=js&"
export * from "./PopupButtons.vue?vue&type=script&lang=js&"
import style0 from "./PopupButtons.vue?vue&type=style&index=0&id=8540f5b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8540f5b0",
  null
  
)

export default component.exports